import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import { WithLoader } from 'Components/WithLoader'
import SchoolForm from 'Services/SchoolManagement/Features/School/Components/SchoolForm'
import { SELECTED_SCHOOL_PARAMETER_KEY } from 'Services/SchoolManagement/Features/School/Hooks/useSchoolsWithParams'
import { useGetSingleSchoolQuery } from 'Services/SchoolManagement/Features/School/schoolApi'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { CONTROL_DATA_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/system'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

function SchoolEditPage() {
  const { id } = useParams()

  const { data: school, isLoading } = useGetSingleSchoolQuery(id ?? '', {
    skip: !id
  })
  const baseUrl = `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/school-management/schools`
  const previousLocation = usePreviousLocation(`${baseUrl}?${SELECTED_SCHOOL_PARAMETER_KEY}=${id}`)

  const breadcrumbs = [
    {
      title: t`Home`,
      link: '/school-management/'
    },
    {
      title: t`Schools`,
      link: baseUrl
    },
    {
      title: t`Edit school`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Edit school`}</PageTitle>
        </Grid>
      </Grid>
      <WithLoader loading={isLoading}>
        <SchoolForm school={school} successBaseUrl={previousLocation} />
      </WithLoader>
    </Box>
  )
}

export default SchoolEditPage
